import { render, staticRenderFns } from "./TaxObligation.vue?vue&type=template&id=5db0b0f8&scoped=true&"
import script from "./TaxObligation.vue?vue&type=script&lang=ts&"
export * from "./TaxObligation.vue?vue&type=script&lang=ts&"
import style0 from "./TaxObligation.vue?vue&type=style&index=0&id=5db0b0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0b0f8",
  null
  
)

export default component.exports